"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TopRightControl = void 0;
var _pittaDesignSystem = require("@thingsw/pitta-design-system");
var _Layers = _interopRequireDefault(require("@material-ui/icons/Layers"));
var _Fullscreen = _interopRequireDefault(require("@material-ui/icons/Fullscreen"));
var _FullscreenExit = _interopRequireDefault(require("@material-ui/icons/FullscreenExit"));
var _FilterList = _interopRequireDefault(require("@material-ui/icons/FilterList"));
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@material-ui/core/styles");
var _clsx5 = _interopRequireDefault(require("clsx"));
var _core = require("@material-ui/core");
var _pittaModules = require("@thingsw/pitta-modules");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      '& > button': _objectSpread(_objectSpread({
        width: 40,
        height: 40,
        backgroundColor: function backgroundColor(props) {
          return props.colors.primary['0'];
        }
      }, theme.direction === 'rtl' ? {
        marginLeft: theme.spacing(1)
      } : {
        marginRight: theme.spacing(1)
      }), {}, {
        '&:last-child': _objectSpread({}, theme.direction === 'rtl' ? {
          marginLeft: 0
        } : {
          marginRight: 0
        }),
        '& svg path': {
          fill: function fill(props) {
            return props.colors.primary['1'];
          }
        }
      })
    },
    roundRoot: {
      '& > button': {
        borderRadius: '50%'
      }
    },
    // mantis - 9421,9416 전체화면일 때 툴팁 안나오는 이슈도 함께 수정 (Leehj)
    iconColor: {
      '&:focus': {
        color: function color(props) {
          return props.colors.primary['1'];
        }
      },
      '&:hover': _objectSpread({
        color: function color(props) {
          return props.colors.primary['7'];
        }
      }, theme.direction === 'rtl' ? {
        marginLeft: 0
      } : {
        marginRight: 0
      }),
      '&:not(:hover)': _objectSpread({}, theme.direction === 'rtl' ? {
        marginLeft: 0
      } : {
        marginRight: 0
      }),
      margin: '0!important'
    },
    active: {
      color: function color(props) {
        return props.colors.primary['1'];
      }
    },
    noHover: {
      '&:hover': {
        color: function color(props) {
          return props.colors.primary['1'] + '!important';
        },
        backgroundColor: function backgroundColor(props) {
          return props.colors.primary['0'] + '!important';
        },
        fill: function fill(props) {
          return props.colors.primary['1'] + '!important';
        }
      },
      '&:active': {
        color: function color(props) {
          return props.colors.primary['1'] + '!important';
        },
        backgroundColor: function backgroundColor(props) {
          return props.colors.primary['0'] + '!important';
        },
        fill: function fill(props) {
          return props.colors.primary['1'] + '!important';
        }
      }
    },
    noFocus: {
      '&:focus': {
        color: function color(props) {
          return props.colors.primary['1'];
        },
        backgroundColor: function backgroundColor(props) {
          return props.colors.primary['0'];
        },
        fill: function fill(props) {
          return props.colors.primary['1'];
        }
      }
    },
    layerFab: {
      padding: 16
    }
  };
});
var TopRightControl = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var _t, _t2, _t3;
  var onFullscreen = _ref.onFullscreen,
    onLayers = _ref.onLayers,
    onDashcamPublic = _ref.onDashcamPublic,
    onEventLayers = _ref.onEventLayers,
    fullscreen = _ref.fullscreen,
    publicRef = _ref.publicRef,
    eventRef = _ref.eventRef,
    layerRef = _ref.layerRef,
    round = _ref.round,
    app = _ref.app,
    activePublic = _ref.activePublic,
    activeAppFilter = _ref.activeAppFilter,
    t = _ref.t,
    themeState = _ref.themeState;
  var classes = useStyles(themeState);
  var theme = (0, _core.useTheme)();
  var mobile = (0, _core.useMediaQuery)(theme.breakpoints.down(_pittaModules.Webviewer.mobile));

  // mantis - 7439, fullsize아이콘 툴팁 제어를 위하여 useState추가(Leehj)
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    openFullSizeTooltip = _useState2[0],
    setOpenFullSizeTooltip = _useState2[1];
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx5["default"])(classes.root, round && classes.roundRoot)
  }, onLayers && /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Tooltip, {
    disableTouchListener: mobile,
    title: (_t = t('Map type')) !== null && _t !== void 0 ? _t : 'Map type',
    PopperProps: {
      // 툴팁때문에 아이콘 움직이는 문제가 있어서 주석처리
      // disablePortal: true,
      modifiers: {
        preventOverflow: {
          enabled: false
        },
        flip: {
          enabled: false
        }
      }
    }
  }, /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Fab, {
    size: "small",
    variant: "rounded"
    // mantis - 12433, Map Type 선택 시 팝업 미노출 이슈 수정, layerRef로 적용 (Leehj)
    ,
    ref: layerRef,
    onClick: onLayers,
    className: (0, _clsx5["default"])(classes.noFocus, classes.layerFab, _defineProperty({}, classes.noHover, mobile))
  }, /*#__PURE__*/_react["default"].createElement(_Layers["default"], null))), onDashcamPublic && /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Tooltip, {
    disableTouchListener: mobile,
    title: (_t2 = t('Public cameras')) !== null && _t2 !== void 0 ? _t2 : 'Public cameras',
    PopperProps: {
      disablePortal: true,
      modifiers: {
        preventOverflow: {
          enabled: false
        },
        flip: {
          enabled: false
        }
      }
    }
  }, /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Fab, {
    onClick: onDashcamPublic,
    size: "small",
    variant: "rounded",
    className: (0, _clsx5["default"])(classes.noFocus, _defineProperty({}, classes.noHover, mobile)),
    ref: publicRef
  }, /*#__PURE__*/_react["default"].createElement(_FilterList["default"], null), !activePublic && !app && /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: 6,
      height: 6,
      borderRadius: 3,
      backgroundColor: _pittaModules.LightColors.primary['7'],
      position: 'absolute',
      top: 3,
      right: 3
    }
  }), !activeAppFilter && app && /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: 6,
      height: 6,
      borderRadius: 3,
      backgroundColor: _pittaModules.LightColors.primary['7'],
      position: 'absolute',
      top: 3,
      right: 3
    }
  }))), onEventLayers && /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Tooltip, {
    disableTouchListener: mobile,
    title: (_t3 = t('Event type')) !== null && _t3 !== void 0 ? _t3 : 'Event type',
    PopperProps: {
      disablePortal: true,
      modifiers: {
        preventOverflow: {
          enabled: false
        },
        flip: {
          enabled: false
        }
      }
    }
  }, /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Fab, {
    size: "small",
    variant: "rounded",
    ref: eventRef,
    onClick: onEventLayers,
    className: (0, _clsx5["default"])(classes.noFocus, _defineProperty({}, classes.noHover, mobile))
  }, /*#__PURE__*/_react["default"].createElement(_Layers["default"], null))), !app && onFullscreen && /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Tooltip
  // mantis - 7439, fullsize아이콘 툴팁 제어를 위하여 툴팁 속성이용 (Leehj)
  , {
    PopperProps: {
      disablePortal: true,
      placement: 'bottom-end',
      modifiers: {
        preventOverflow: {
          enabled: false
        },
        flip: {
          enabled: false
        }
      }
    },
    open: openFullSizeTooltip,
    onOpen: function onOpen() {
      return setOpenFullSizeTooltip(true);
    },
    onClose: function onClose() {
      return setOpenFullSizeTooltip(false);
    },
    disableTouchListener: mobile,
    title: fullscreen ? "".concat(t('Exit fullscreen')) : "".concat(t('Fullscreen'))
  }, /*#__PURE__*/_react["default"].createElement(_pittaDesignSystem.Fab, {
    size: "small",
    variant: "rounded"
    // mantis - 7439, safari에서 지도 전체화면 종료 시에도 툴팁남아있는 이슈수정/ 아이콘 클릭하면 툴팁 close (Leehj)
    ,
    onClick: function onClick() {
      onFullscreen();
      setOpenFullSizeTooltip(false);
    },
    className: (0, _clsx5["default"])(classes.noFocus, classes.iconColor, _defineProperty({}, classes.noHover, mobile))
  }, fullscreen ? /*#__PURE__*/_react["default"].createElement(_FullscreenExit["default"], null) : /*#__PURE__*/_react["default"].createElement(_Fullscreen["default"], null))));
});
exports.TopRightControl = TopRightControl;